<template>
	<div>
		<Breadcrumbs main="surcharge.resource" title="surcharge.header"/>
		<!-- Container-fluid starts-->
		<div class="container-fluid">
            <div>
                <div v-show="process === 'add'" class="row ">
                    <div id="addFght" class="col-sm-12 gradient-wy">
                        <div class="row col-sm-8 mx-1">
                            <div class="row ml-3" v-b-hover="handleHover">
                                <h2 class="text-primary mt-3">{{ $t('surcharge.add') }}</h2>
                                <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="clickCancelProcess">&times;</span>
                                <span v-show="isHovered" class="text-danger">{{ $t('surcharge.cancelReturn')  }} </span>
                            </div>
                            <div class="row ml-5">
                                <h3 class="mt-4 text-dark">{{ $t('bookingId.agent') }} :</h3>
                                <h3 class="mt-4 ml-2 text-info"> {{ this.selectedAgent }}</h3>
                            </div>
                        </div>
                        <form class="theme-form">
                            <div class="ml-2"> 
                                <div class="row col-sm-12">
                                    <div class="col-sm-3">
                                        <label for="selectedSurCode" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("surcharge.surCode") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedSurCode" 
                                            :reduce="text => text.value"
                                            label = 'text'
                                            :options="surCodeOptions" 
                                            :placeholder="$t('surcharge.plsSelect')"
                                        >                         
                                        </v-select>
                                    </div> 
                                    <div class="col-sm-1 mt-1">
                                        <label for="effDate" class="f-w-600 text-primary" style="font-size: 16px">{{ $t("freight.effDate") }}</label>
                                        <datepicker input-class="datepicker-here form-control digits bg-white" :format="format" v-model="effDate" ></datepicker>
                                    </div>  
                                    <div class="col-sm-1 mt-1">
                                        <label for="expDate" class="f-w-600 text-primary" style="font-size: 16px">{{ $t("freight.expDate") }}</label>
                                        <datepicker input-class="datepicker-here form-control digits bg-white"  :disabled-dates="disabledDates"  :format="format" v-model="expDate" ></datepicker>
                                    </div>
                                    <div class="col-sm-3">
                                        <label for="selectedAppnEx" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("surcharge.appnEx") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedAppnEx" 
                                            :reduce="text => text.value"
                                            label = 'text'
                                            :options="exitList"     
                                        >                            
                                        </v-select>
                                    </div> 
                                    <div class="col-sm-3">
                                        <label for="selectedAppnTo" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("surcharge.appnTo") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedAppnTo" 
                                            :options="srvScpList" 
                                            :placeholder="$t('surcharge.plsSelect')"
                                        >                                
                                        </v-select>
                                    </div>                             
                                </div>
                                <div class="row col-sm-12 mt-2">
                                    <div class="row mx-1 col-sm-1">
                                            <label for="contType" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("matchTx.contType") }}</label>                                                                       
                                            <b-form-select 
                                                class="style-chooser" 
                                                style="font-size:16px;" 
                                                v-model="contType" 
                                                :options="optionsContType" 
                                            >                            
                                            </b-form-select>
                                    </div>
                                    <div class="row mx-1 col-sm-2">
                                            <label for="selectedRateBase" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("surcharge.rateBase") }}</label>                                                                       
                                            <b-form-select 
                                                class="style-chooser" 
                                                style="font-size:16px;" 
                                                v-model="selectedRateBase" 
                                                :options="rateBaseList" 
                                            >   
                                            <template #first>
                                                <b-form-select-option :value="''" disabled>{{ $t("surcharge.plsSelect") }}</b-form-select-option>
                                            </template>                             
                                            </b-form-select>
                                    </div>
                                    <div class="row mx-1 col-sm-1">
                                            <label for="selectedCurr" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("freight.currency") }}</label>                                                                       
                                            <b-form-select 
                                                class="style-chooser" 
                                                style="font-size:16px;" 
                                                v-model="selectedCurr" 
                                                :options="currencies" 
                                            >                            
                                            </b-form-select>
                                    </div>
                                    <div v-show="selectedRateBase != 'SIZE'" class="row mx-1 col-sm-1">
                                        <div role="group" v-b-popover.hover.top="$t('surcharge.surRateDetails')">
                                            <label for="surRate" class="col-form-label pt-0 f-w-600">{{$t("surcharge.surRate") }}</label>
                                            <b-form-input 
                                                id="surRate"
                                                style="font-size:16px;" 
                                                v-model="surRate"  
                                                type="number" 
                                                :state="surRateState"
                                                aria-describedby="input-live-feedback-SurRate"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-SurRate"> {{`${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                      
                                        </div>                                        
                                    </div>
                                    <div v-show="selectedRateBase == 'SIZE'" class="row mx-3">
                                        <div role="group" v-b-popover.hover.top="$t('freight.L20Details')">
                                            <label for="L20" class="col-form-label pt-0 f-w-600">{{$t("freight.L20") }}</label>
                                            <b-form-input 
                                                id="L20"
                                                style="font-size:16px;" 
                                                v-model="L20"  
                                                type="number" 
                                                :state="L20State"
                                                aria-describedby="input-live-feedback-L20"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L20"> {{`${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                      
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40Details')">
                                            <label for="L40" class="col-form-label pt-0 f-w-600">{{$t("freight.L40") }}</label>
                                            <b-form-input 
                                                id="L40"
                                                style="font-size:16px;" 
                                                v-model="L40"  
                                                type="number" 
                                                :state="L40State"
                                                aria-describedby="input-live-feedback-L40"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40"> {{`${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                             
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40HCDetails')">
                                            <label for="L40HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L40HC") }}</label>
                                            <b-form-input 
                                                id="L40HC"
                                                style="font-size:16px;" 
                                                v-model="L40HC"  
                                                type="number" 
                                                :state="L40HCState"
                                                aria-describedby="input-live-feedback-L40HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                     
                                        </div>

                                    </div>
                                    <div v-show="selectedRateBase == 'SIZE'" class="row mx-1">
                                        <div role="group" v-b-popover.hover.top="$t('freight.L20HCDetails')">
                                            <label for="L20HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L20HC") }}</label>
                                            <b-form-input 
                                                id="L20HC"
                                                style="font-size:16px;" 
                                                v-model="L20HC"  
                                                type="number" 
                                                :state="L20HCState"
                                                aria-describedby="input-live-feedback-L20HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L20HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                     
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L45Details')">
                                            <label for="L45" class="col-form-label pt-0 f-w-600">{{$t("freight.L45") }}</label>
                                            <b-form-input 
                                                id="L45"
                                                style="font-size:16px;" 
                                                v-model="L45"  
                                                type="number" 
                                                :state="L45State"
                                                aria-describedby="input-live-feedback-L45"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L45"> {{`${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                             
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L45HCDetails')">
                                            <label for="L45HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L45HC") }}</label>
                                            <b-form-input 
                                                id="L45HC"
                                                style="font-size:16px;" 
                                                v-model="L45HC"  
                                                type="number" 
                                                :state="L45HCState"
                                                aria-describedby="input-live-feedback-L45HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L45HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                     
                                        </div>
                                    </div>
                                    <div class="col-sm-1 mt-4">
                                        <button class="btn btn-primary btn-block" style="font-size:20px" type="button" @click="handleSave">{{ $t('container.save') }}</button>
                                    </div>        
                                    <div class="col-sm-1 mt-4">
                                        <button class="btn btn-danger btn-block" style="font-size:20px" type="button btn-danger" @click="clickCancelProcess">{{ $t('matchTx.cancel') }}</button>
                                    </div>               
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div v-show="process === 'update' " class="row">
                    <div class="col-sm-12 gradient-ow">
                        <div class="row col-sm-8 mx-1">
                            <div class="row ml-3" v-b-hover="handleHover">
                                <h3 class="text-primary mt-3">{{ $t('surcharge.edit') }}</h3>
                                <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="clickCancelProcess">&times;</span>
                                <span v-show="isHovered" class="text-danger">{{ $t('surcharge.cancelReturn')  }} </span>
                            </div> 
                            <div class="row ml-5">
                                <h3 class="mt-4 text-dark">{{ $t('bookingId.agent') }} :</h3>
                                <h3 class="mt-4 ml-2 text-info"> {{ this.selectedAgent }}</h3>
                            </div>                           
                        </div>
                        <form class="theme-form">
                            <div class="ml-2"> 
                                <div class="row col-sm-12">
                                    <div class="col-sm-2">
                                        <label for="selectedSurCode" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("surcharge.surCode") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedSurCode" 
                                            :reduce="text => text.value"
                                            label = 'text'
                                            :options="surCodeOptions" 
                                            disabled
                                        >                            
                                        </v-select>
                                    </div> 

                                    <div class="col-sm-1 mt-1">
                                        <label for="effDate" class="f-w-600 text-primary" style="font-size: 16px">{{ $t("surcharge.effDate") }}</label>
                                        <datepicker input-class="datepicker-here form-control digits bg-warning" disabled :format="format" v-model="effDate" ></datepicker>
                                    </div>  
                                    <div class="col-sm-1 mt-1">
                                        <label for="expDate" class="f-w-600 text-primary" style="font-size: 16px">{{ $t("surcharge.expDate") }}</label>
                                        <datepicker input-class="-here form-control digits  bg-warning"  :disabled-dates="disabledDates"  :format="format" v-model="expDate" ></datepicker>
                                    </div>
                                    <div class="col-sm-3">
                                        <label for="selectedAppnEx" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("surcharge.appnEx") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedAppnEx" 
                                            :reduce="text => text.value"
                                            label = 'text'
                                            :options="exitList" 
                                            disabled
                                        >                            
                                        </v-select>
                                    </div> 
                                    <div class="col-sm-3">
                                        <label for="selectedAppnTo" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("surcharge.appnTo") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedAppnTo" 
                                            :options="srvScpList" 
                                            disabled
                                        >                            
                                        </v-select>
                                    </div>   
                         
                                </div>
                                <div class="row col-sm-12 mt-2">
                                    <div class="row mx-1 col-sm-1">
                                            <label for="contType" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("matchTx.contType") }}</label>                                                                       
                                            <b-form-select 
                                                class="style-chooser" 
                                                style="font-size:16px;" 
                                                v-model="contType" 
                                                :options="optionsContType" 
                                            >                            
                                            </b-form-select>
                                    </div>
                                    <div class="row mx-1 col-sm-2">
                                            <label for="selectedRateBase" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("surcharge.rateBase") }}</label>                                                                       
                                            <b-form-select 
                                                class="style-chooser" 
                                                style="font-size:16px;" 
                                                v-model="selectedRateBase" 
                                                :options="rateBaseList" 
                                            >                            
                                            </b-form-select>
                                    </div>
                                    <div class="row mx-1 col-sm-1 ">
                                        <label for="selectedCurrency" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("freight.currency") }}</label>                                                                       
                                        <b-form-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedCurr" 
                                            :options="currencies" 
                                        >                            
                                        </b-form-select>                                        
                                    </div>
                                    <div v-show="selectedRateBase != 'SIZE'" class="row mx-1 col-sm-1">
                                        <div role="group" v-b-popover.hover.top="$t('surcharge.surRateDetails')">
                                            <label for="surRate" class="col-form-label pt-0 f-w-600">{{$t("surcharge.surRate") }}</label>
                                            <b-form-input 
                                                id="surRate"
                                                style="font-size:16px;" 
                                                v-model="surRate"  
                                                type="number" 
                                                :state="surRateState"
                                                aria-describedby="input-live-feedback-SurRate"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-SurRate"> {{`${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                      
                                        </div>                                        
                                    </div>
                                    <div v-show="selectedRateBase == 'SIZE'" class="row mx-3">
                                        <div role="group" v-b-popover.hover.top="$t('freight.L20Details')">
                                            <label for="L20" class="col-form-label pt-0 f-w-600">{{$t("freight.L20") }}</label>
                                            <b-form-input 
                                                id="L20"
                                                style="font-size:16px;" 
                                                v-model="L20"  
                                                type="number" 
                                                :state="L20State"
                                                aria-describedby="input-live-feedback-L20"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L20"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}`}}</b-form-invalid-feedback>                      
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40Details')">
                                            <label for="L40" class="col-form-label pt-0 f-w-600">{{$t("freight.L40") }}</label>
                                            <b-form-input 
                                                id="L40"
                                                style="font-size:16px;" 
                                                v-model="L40"  
                                                type="number" 
                                                :state="L40State"
                                                aria-describedby="input-live-feedback-L40"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40"> {{ $t("freight.fght10000Allow") }}</b-form-invalid-feedback>                             
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40HCDetails')">
                                            <label for="L40HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L40HC") }}</label>
                                            <b-form-input 
                                                id="L40HC"
                                                style="font-size:16px;" 
                                                v-model="L40HC"  
                                                type="number" 
                                                :state="L40HCState"
                                                aria-describedby="input-live-feedback-L40HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}`}}</b-form-invalid-feedback>                     
                                        </div>
                                    </div>
                                    <div v-show="selectedRateBase == 'SIZE'" class="row mx-3">
                                        <div role="group" v-b-popover.hover.top="$t('freight.L20HCDetails')">
                                            <label for="L20HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L20HC") }}</label>
                                            <b-form-input 
                                                id="L20HC"
                                                style="font-size:16px;" 
                                                v-model="L20HC"  
                                                type="number" 
                                                :state="L20HCState"
                                                aria-describedby="input-live-feedback-L20HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L20HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                     
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L45Details')">
                                            <label for="L45" class="col-form-label pt-0 f-w-600">{{$t("freight.L45") }}</label>
                                            <b-form-input 
                                                id="L45"
                                                style="font-size:16px;" 
                                                v-model="L45"  
                                                type="number" 
                                                :state="L45State"
                                                aria-describedby="input-live-feedback-L45"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L45"> {{`${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                             
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L45HCDetails')">
                                            <label for="L45HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L45HC") }}</label>
                                            <b-form-input 
                                                id="L45HC"
                                                style="font-size:16px;" 
                                                v-model="L45HC"  
                                                type="number" 
                                                :state="L45HCState"
                                                aria-describedby="input-live-feedback-L45HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L45HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                     
                                        </div>
                                    </div>
                                    <div class="col-sm-1 mt-4">
                                        <button class="btn btn-warning btn-block" style="font-size:20px"  type="button" @click="handleUpdate">{{ $t('container.update') }}</button>
                                    </div>  
                                    <div class="col-sm-1 mt-4">
                                        <button class="btn btn-danger btn-block" style="font-size:20px"  type="button" @click="clickCancelProcess">{{ $t('matchTx.cancel') }}</button>
                                    </div>                                
                                </div>
                            </div>
                        </form>
                    </div>
                </div>                
                <div class="divider"> </div>                    
                <div class="row">
                    <h2 class="ml-4 mt-5 f-w-600">{{ $t('surcharge.surList') }}</h2>
                    <h2 class="mx-4 mt-5 f-w-600 text-danger"> :: </h2> 
                    <div class="col-sm-3 row gradient-wb">
                        <label for="selectedAgent" class="col-form-label pt-0 f-w-600" style="font-size:18px;"> {{ $t("surcharge.agentSurcharge") }}</label>                                                                       
                        <v-select 
                            class="style-chooser text-primary" 
                            style="font-size:18px;" 
                            v-model="selectedAgent" 
                            :options="agentList" 
                            @input="trigSurListByAgent"
                            :placeholder="$t('surcharge.plsSelect')"
                        >    >                            
                        </v-select>
                    </div>
                    <b-button size="sm" variant="primary" :disabled="!selectedAgent" @click="selectedAgent = ''" class="mt-5 ml-3">
                        {{ $t('matchTx.clear') }}
                    </b-button>                    
                    <h2 class="mx-2 mt-5 f-w-600 text-danger"> :: </h2> 
                    <b-button v-show="process === 'info'" pill href="#addFght" size="sm" @click="clickAddSur" class="bg-primary mt-5 ml-3 ">
                        <span class="f-w-600 text-white" style="font-size: 20px;">{{ $t('freight.add') }} </span>
                    </b-button>                         
                </div>
                <div class="row mt-3">    
                    <b-col lg="4">
                        <b-form-group
                        :label="$t('matchTx.filter')"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            id="filter-input"
                            v-model="filter"
                            type="search"
                            :placeholder="$t('matchTx.typeToSearch')"
                            class="text-info"
                            style="font-size: 18px;"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                                {{ $t('matchTx.clear') }}
                            </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6" >
                        <b-form-group
                        v-model="sortDirection"
                        :label="$t('matchTx.filterOn')"
                        :description= "$t('matchTx.uncheck')"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        v-slot="{ ariaDescribedby }"
                        >
                        <b-form-checkbox-group
                            v-model="filterOn"
                            :aria-describedby="ariaDescribedby"
                            class="text-info"
                            plain
                        >
                            <!-- <b-form-checkbox value="agent">{{ $t('bookingId.agent') }}</b-form-checkbox>                                                                 -->
                            <b-form-checkbox value="surCode">{{ $t('surcharge.surCode') }}</b-form-checkbox>
                            <b-form-checkbox value="appnEx">{{ $t('surcharge.appnEx') }}</b-form-checkbox>                               
                            <b-form-checkbox value="appnTo">{{ $t('surcharge.appnTo') }}</b-form-checkbox>   
                        </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>   
                </div>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="white"
                    show-empty
                    sort-icon-left
                    stacked="md"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync= "sortDesc"
                    :sort-direction="sortDirection"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFiltered"
                >
                    <!-- A virtual column -->
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(detailsSurCode)="row" >
                        <b-button size="sm" @click="openModalDetailsSurCode(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('surcharge.detailsSurCode')">
                            {{ row.item.surCode}}
                        </b-button>
                    </template>
                    <template #cell(detailsAppnEx)="row" >
                        <b-button size="sm" @click="openModalDetailsAppnEx(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('surcharge.detailsAppnEx')">
                            {{ row.item.appnEx}}
                        </b-button>
                    </template>
                    <template #cell(actions)="row" >
                        <b-button pill size="sm" @click="actUpdate(row.item)" class="m-1 btn-warning">
                           <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.update') }}</span>
                        </b-button>
                        <b-button pill size="sm" @click="actDelete(row.item)" class="m-1 btn-danger">
                            <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.delete') }}</span>
                        </b-button>                        
                    </template>
                    <template #empty>
                        <h3 class="text-danger">{{ $t('surcharge.noRecord') }}</h3>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8 ">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('require.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
            </div>
            <b-modal id="detailsSurCodeModal" :title="$t('surcharge.detailsSurCode')" size="md" ok-only @hide="resetModalDetailsSurCode">
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('surcharge.surCode') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{this.selectedSurCode }}</h3>
                </div>   
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('surcharge.surDesc') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{this.surDesc }}</h3>
                </div>                
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('slip.remark') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{ this.remark}}</h3>
                </div>
            </b-modal>
            <b-modal id="detailsAppnExModal" :title="$t('freight.detailsPort')" size="md" ok-only @hide="resetModalDetailsAppnEx">
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('port.portId') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{this.portId }}</h3>
                </div>   
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('port.pName') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{this.pName }}</h3>
                </div>                
            </b-modal>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>
import { agentList, getData,saveWithId, compNameEngByCompId, deleteItem, getAllSurCodeList ,getSrvScpList,getPortExitList, } from "../../firebase"
import {currencies, inputLimitUSD , contType, rateBase} from '../../constants/config'
export default {
	data(){
		return{
            compId : '',
            compName : '',
            process : "info",
            isHovered: false,
            selectedSurCode : '',
            surCodeOptions : [],
            effDate : '',
            expDate : '',
            format: "yyyy-MM-dd",
            surId : '',
            surDesc: '',
            remark :'',            
            portId : '',
            pName : '',
            disabledDates: {
                to: new Date(Date.parse(new Date())-86400000),
            },
            selectedAgent : "",                     
            agentList : [],  
            contType: 'ALL',
            optionsContType : [],
            selectedAppnEx : 'ALL',               
            exitList : [],   
            selectedAppnTo : '',               
            srvScpList : [],   
            currencies : currencies,
            selectedCurr : 'USD',
            rateMaxAllow : 10000 ,
            selectedRateBase : '',
            rateBaseList : rateBase,
            surRate : 0,
            L20 : 0,
            L40 : 0,
            L40HC : 0,    
            L20HC : 0,   
            L45 : 0,
            L45HC : 0,    
            items: [],
            fields: [
                { key: 'index', label: this.$t('seal.item'), sortable: true , variant: 'info'},     
                { key: 'detailsSurCode', label: this.$t('surcharge.surCode'), sortable: true , variant: 'info'},
                { key: 'surId', label: this.$t('surcharge.surId'), sortable: true , variant: 'info'},               
                { key: 'effDateTS', label: this.$t('surcharge.effDate'), sortable: true , variant: 'primary', 
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }},                
                { key: 'expDateTS', label: this.$t('surcharge.expDate'), sortable: true , variant: 'primary', 
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }},                                       
                { key: 'detailsAppnEx', label: this.$t('surcharge.appnEx'), sortable: true , variant: 'info'},  
                { key: 'appnTo', label: this.$t('surcharge.appnTo'), sortable: true , variant: 'info'},  
                { key: 'contType', label: this.$t('matchTx.contType'), sortable: true , variant: 'primary',                     
                    formatter: value => {
                        return value.toUpperCase()
                }}, 
                { key: 'rateBase', label: this.$t('surcharge.rateBase'), variant: 'primary' }, 
                { key: 'curr', label: this.$t('freight.currency'), variant: 'primary' },                    
                { key: 'surRate', label: this.$t('surcharge.surRate'),variant: 'warning' },  
                { key: 'L20', label: this.$t('freight.L20'), variant: 'success' }, 
                { key: 'L40', label: this.$t('freight.L40'),variant: 'success' },  
                { key: 'L40HC', label: this.$t('freight.L40HC'), variant: 'success'},  
                { key: 'L20HC', label: this.$t('freight.L20HC'), variant: 'secondary'},  
                { key: 'L45', label: this.$t('freight.L45'),variant: 'secondary' },  
                { key: 'L45HC', label: this.$t('freight.L45HC'), variant: 'secondary'},  
                { key: 'actions', label: this.$t('matchTx.actions'), variant: 'warning'},
                { key: 'ts', label: this.$t('driver.recordAt'), sortable: true , variant: 'info', 
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }}, 
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'ts',
            sortDesc: true,
            sortDirection: 'desc',
            filter: null,
            filterOn: [],
		}
	},
    computed: {
        sortOptions() {
            return this.fields
            .filter(f => f.sortable)
            .map(f => {
                return { text: f.label, value: f.key }
            })
        },
        surRateState() {
           this.rateSwitch()
            return this.surRate <= this.rateMaxAllow ? true : false
        },   
        L20State() {
           this.rateSwitch()
            return this.L20 <= this.rateMaxAllow ? true : false
        },       
        L40State() {
            this.rateSwitch()
            return this.L40 <= this.rateMaxAllow? true : false
        }, 
        L40HCState() {
            this.rateSwitch()
            return this.L40HC <= this.rateMaxAllow ? true : false
        }, 
        L20HCState() {
            this.rateSwitch()
            return this.L20HC <= this.rateMaxAllow ? true : false
        }, 
        L45State() {
            this.rateSwitch()
            return this.L45 <= this.rateMaxAllow? true : false
        }, 
        L45HCState() {
            this.rateSwitch()
            return this.L45HC <= this.rateMaxAllow ? true : false
        }, 
    },
	mounted(){
        this.compId= localStorage.getItem("compId")
        compNameEngByCompId (this.compId, (res)=>{
            this.compName =res
        })
        agentList((res)=>{
            this.agentList = res.sort()
        })
        getAllSurCodeList((res)=>{
            this.surCodeOptions = res
        })
        getPortExitList( "TH", (res)=>{
            this.exitList = res
        })
        getSrvScpList((res)=>{
            this.srvScpList = res
        })
        this.optionsContType = contType.concat({
            text : `${this.$t('surcharge.allTypes')}`,
            value : 'ALL'
        })    
	},
	methods:{
        rateSwitch(){
            switch (this.selectedCurr) {
                case 'USD':
                    this.rateMaxAllow = inputLimitUSD
                    break;
                case 'EUR':
                    this.rateMaxAllow = inputLimitUSD * 0.86
                break;
                case 'JPY':
                    this.rateMaxAllow = inputLimitUSD * 150
                    break;
                case 'GBP':
                    this.rateMaxAllow = inputLimitUSD * 0.75
                break;
                case 'CNY':
                    this.rateMaxAllow = inputLimitUSD * 7.13
                break;
                case 'AUD':
                    this.rateMaxAllow = inputLimitUSD * 1.54
                    break;
                case 'CAD':
                    this.rateMaxAllow = inputLimitUSD * 1.4
                break;
                default:
                    break;
            }
        },
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },        
        handleHover(hovered) {
            this.isHovered = hovered
        },
        clickCancelProcess(){
            this.process = 'info'
            this.refresh()
        },
        async trigSurListByAgent( value){
            if (value) {
                // await getData( 'Surcharge','agent', this.selectedAgent, async(res)=>{
                //     this.items = res 
                //     this.totalRows = res.length
                // })
                this.refresh()
            } 
            else {
                this.items = []
                this.totalRows = 0
                this.$toasted.show(this.$t('bookingId.selAgent'), {theme: 'bubble', type: 'info' , position: 'bottom-center', duration: 5000}); 
            }
        },
        clickAddSur() {
            if (this.selectedAgent != '') {
                this.process = 'add'
            } else {
                this.$bvModal.msgBoxConfirm(this.$t('surcharge.selAgent'), {
                title: this.$t('bookingId.selAgent'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'warning',
                okTitle: this.$t('matchTx.yes'),
                // cancelTitle: this.$t('matchTx.no'),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
                })
                .then(async(value) => {
                    if (value) {
                        this.process = 'info'
                    } else {
                        return
                    }
                })
                .catch(error => {
                    this.$toasted.show( `Click add Surcharge: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                })
            }
         
        },   

        async handleSave(){
            let msg = 'completed'
            if (this.selectedSurCode ===''){
                msg = 'surcharge.selSurCode'
            } else if (this.effDate ===''){
                msg = 'surcharge.addEffDate'
            } else if (this.expDate ===''){
                msg = 'surcharge.addExpDate'
            } else if (Date.parse(this.expDate) < Date.parse(this.effDate)){
                msg = 'surcharge.expDateMoreThanEffDate'
            } else if (this.selectedAppnEx === ''){
                msg = 'surcharge.selAppnEx'
            } else if (this.selectedAppnTo === ''){
                msg = 'surcharge.selAppnTo'
            } else if (this.selectedRateBase === ''){
                msg = 'surcharge.selRateBase'
            } 
            if (msg === 'completed'){  
                let surId = `${this.selectedAgent.slice(0,3).trim()}-${this.selectedSurCode.slice(0,3)}-${this.contType.toUpperCase()}-${this.selectedAppnEx.trim()}${this.$moment(this.effDate).format("YYMMDD")}${this.selectedAppnTo.trim()}`
                await getData('Surcharge', 'surId', surId, async(res)=>{
                    if (res.length == 0 ) {
                        await this.saveSur(surId).then(async()=>{
                            await this.refreshAdd()
                        })  
                    } else {
                       await this.confirmSaveSur(surId) 
                    }
                } ) 
            } else {
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },

        async saveSur(surId){
            let mExpDate = this.$moment(this.expDate).format("YYYY-MM-DD")            
            let payload = {
                surCode :this.selectedSurCode,
                surId : surId,
                effDateTS : Date.parse(this.effDate),
                expDateTS : Date.parse(mExpDate + ' ' + '23:59:59'),
                agent : this.selectedAgent,                     
                appnEx : this.selectedAppnEx,                  
                appnTo : this.selectedAppnTo,
                contType : this.contType,
                rateBase : this.selectedRateBase,                
                curr : this.selectedCurr,   
                surRate : this.surRate, 
                L20 : this.L20,
                L40 :this.L40,
                L40HC : this.L40HC,
                L20HC : this.L20HC,   
                L45 :this.L45,
                L45HC : this.L45HC,
                ts : Date.parse(new Date())
            }
            await saveWithId('Surcharge', surId, payload).then(async()=>{
                this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                                                    
            })
        },

        confirmSaveSur(surId) {
            this.$bvModal.msgBoxConfirm(this.$t('surcharge.confirmSaveSurMsg'), {
            title: this.$t('freight.plsConfirmOverwrite'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await this.saveSur(surId).then(async()=>{
                    await this.refreshAdd()
                 })                
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },  
        actDelete(item) {
            this.$bvModal.msgBoxConfirm(this.$t('container.confirmDeleteMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await deleteItem( "Surcharge", item.surId)
                    await this.refresh()                   
                    this.$toasted.show( this.$t('container.deleted'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },    
        async refreshAdd(){
            await getData( "Surcharge", 'agent', this.selectedAgent,(res)=>{
                this.items = res
                this.totalRows = res.length
            })
            this.surId = ''
            // this.selectedSurCode = ''
            // this.effDate = ''
            // this.expDate = ''      
            // this.selectedAppnEx = 'ALL'             
            this.selectedAppnTo = ''    
            // this.contType = 'ALL'
            // this.selectedRateBase = ''     
            // this.selectedCurr = 'USD'
            // this.surRate = 0
            // this.L20 = 0
            // this.L40 = 0
            // this.L40HC = 0
            // this.L20HC = 0
            // this.L45 = 0
            // this.L45HC = 0
            // this.process = 'info'
        },
        async refresh(){
            await getData( "Surcharge", 'agent', this.selectedAgent,(res)=>{
                this.items = res
                this.totalRows = res.length
            })
            this.surId = ''
            this.selectedSurCode = ''
            this.effDate = ''
            this.expDate = ''              
            this.selectedAppnEx = 'ALL'             
            this.selectedAppnTo = ''  
            this.contType = 'ALL'              
            this.selectedRateBase = ''            
            this.selectedCurr = 'USD'
            this.surRate = 0
            this.L20 = 0
            this.L40 = 0
            this.L40HC = 0
            this.L20HC = 0
            this.L45 = 0
            this.L45HC = 0          
            this.process = 'info'
        },
        async handleUpdate(){
            let msg = 'completed'
            if (this.selectedSurCode ===''){
                msg = 'surcharge.selSurCode'
            } else if (this.effDate ===''){
                msg = 'surcharge.addEffDate'
            } else if (this.expDate ===''){
                msg = 'surcharge.addExpDate'
            } else if (Date.parse(this.expDate) < Date.parse(this.effDate)){
                msg = 'surcharge.expDateMoreThanEffDate'
            } else if (this.selectedAppnEx === ''){
                msg = 'surcharge.selAppnEx'
            } else if (this.selectedAppnTo === ''){
                msg = 'surcharge.selAppnTo'
            } else if (this.selectedRateBase === ''){
                msg = 'surcharge.selRateBase'
            } 
            if (msg === 'completed'){
                await this.saveSur(this.surId).then(async()=>{
                    await this.refresh()
                })
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },

        async actUpdate(item) {
            this.process = "update"   // to pop up Update subMenu
            this.surId = item.surId
            this.selectedAgent = item.agent
            this.selectedSurCode = item.surCode
            this.effDate = this.$moment(item.effDateTS).format("YYYY-MM-DD")
            this.expDate = this.$moment(item.expDateTS).format("YYYY-MM-DD")              
            this.selectedAppnEx = item.appnEx           
            this.selectedAppnTo = item.appnTo
            this.contType = item.contType
            this.selectedRateBase = item.rateBase
            this.selectedCurr = item.curr
            this.surRate = item.surRate
            this.L20 = item.L20
            this.L40 = item.L40
            this.L40HC = item.L40HC
            this.L20HC = item.L20HC
            this.L45 = item.L45
            this.L45HC = item.L45HC
       
        }, 
        async openModalDetailsSurCode(item, index, button) {
          await getData( 'SurCode' ,'id' , item.surCode, (res)=>{
            this.selectedSurCode= res[0].id
            this.surDesc = res[0].surDesc
            this.remark = res[0].remark
          })
          this.$root.$emit('bv::show::modal', "detailsSurCodeModal" , button)
        },
        async openModalDetailsAppnEx(item, index, button) {
            if (item.appnEx == 'ALL') {
                this.portId = 'ALL'
                this.pName = 'All Ports of Loading'
            } else {
                await getData( 'Port' ,'id' , item.appnEx, (res)=>{
                    this.portId = res[0].id
                    this.pName = res[0].pName.trim()
                })  
            }
          this.$root.$emit('bv::show::modal', "detailsAppnExModal" , button)
        },
        resetModalDetailsSurCode() {
            this.selectedSurCode = ''
            this.surDesc = ''
            this.remark = ''
        },

        resetModalDetailsAppnEx() {
            this.portId = ''
            this.pName = ''
            this.cntry = ''
        },
    }
}
</script>
<style scoped>
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-ow {
   background: linear-gradient(135deg, orange, white);
 }
 .gradient-wb {
   background: linear-gradient(135deg, white, rgb(0, 145, 255));
 }

.divider {
    height: 5px;
    background-color: #f10909;
    margin:5px
}
</style>
